import React from "react";
import { Star, Quote } from "lucide-react";
import { useI18n } from "../i18n";

export default function Testimonials() {
  const { t } = useI18n();

  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-32 border-t border-[#2d2622]"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="divider-gold" />
            <span className="overline">{t.testimonials.overline}</span>
          </div>
          <h2
            className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-light leading-tight text-[#f4f0eb]"
            data-testid="testimonials-title"
          >
            {t.testimonials.title}
          </h2>
          <p className="mt-6 text-[#a39e97] text-base md:text-lg">
            {t.testimonials.subtitle}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.testimonials.reviews.map((r, idx) => (
            <article
              key={idx}
              className="relative bg-[#141210] border border-[#2d2622] p-8 flex flex-col hover:border-[#6a1a22] transition-colors duration-500"
              data-testid={`testimonial-card-${idx}`}
            >
              <Quote
                size={28}
                className="text-[#6a1a22] mb-4"
                strokeWidth={1.5}
              />
              <div
                className="flex items-center gap-1 mb-4"
                data-testid={`testimonial-rating-${idx}`}
              >
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    className="fill-[#d4af37] text-[#d4af37]"
                  />
                ))}
              </div>
              <p className="text-[#d9d4cd] text-[15px] leading-relaxed italic font-light flex-1">
                “{r.text}”
              </p>
              <div className="mt-6 pt-5 border-t border-[#2d2622]">
                <div className="font-serif-display text-lg text-[#f4f0eb]">
                  {r.name}
                </div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-[#a39e97] mt-1">
                  {r.role} · {r.when}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
